import { Component, Vue } from 'vue-property-decorator'
import { getReferralProgramConditions } from '~/lib/utils/referralProgram'

@Component
export default class ReferralModalConditions extends Vue {
  get referralModalVisibilityConditions() {
    const baseConditions = getReferralProgramConditions(this.$auth.user, this.$featureFlags)
    const isReferralModalSeen = this.$cookies.get('referral-modal-seen')

    return {
      ...baseConditions,
      isReferralModalSeen: !isReferralModalSeen
    }
  }
}
